<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7318_63439)">
      <path
        d="M0 2.95055C0 4.48922 2.65273 5.2943 5.27343 5.2943C7.89413 5.2943 10.5469 4.48922 10.5469 2.95055C10.5469 -0.126746 0 -0.126746 0 2.95055Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 6.46679C3.37699 6.46679 0 5.91121 0 4.12305V5.29492C0 6.83007 2.64843 7.63867 5.27343 7.63867C7.89842 7.63867 10.5469 6.83007 10.5469 5.29492V4.12305C10.5469 5.90953 7.18581 6.46679 5.27343 6.46679Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 11.1543C2.64843 11.1543 0 10.3457 0 8.81055V9.98242C0 11.5176 2.64843 12.3262 5.27343 12.3262C7.89842 12.3262 10.5469 11.5176 10.5469 9.98242V8.81055C10.5469 10.3457 7.89842 11.1543 5.27343 11.1543Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 13.4976C2.64843 13.4976 0 12.689 0 11.1538V12.3257C0 13.8608 2.64843 14.6694 5.27343 14.6694C7.89842 14.6694 10.5469 13.8608 10.5469 12.3257V11.1538C10.5469 12.689 7.89842 13.4976 5.27343 13.4976Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 15.8413C2.64843 15.8413 0 15.0327 0 13.4976V14.6694C0 16.2046 2.64843 17.0132 5.27343 17.0132C7.89842 17.0132 10.5469 16.2046 10.5469 14.6694V13.4976C10.5469 15.0327 7.89842 15.8413 5.27343 15.8413Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 18.1851C2.64843 18.1851 0 17.3765 0 15.8413V17.0132C0 18.5483 2.64843 19.3569 5.27343 19.3569C7.89842 19.3569 10.5469 18.5483 10.5469 17.0132V15.8413C10.5469 17.3765 7.89842 18.1851 5.27343 18.1851Z"
        fill="#8B90A4"
      />
      <path
        d="M5.27343 8.81054C2.64843 8.81054 0 8.00195 0 6.4668V7.63867C0 9.42683 3.37699 9.98242 5.27343 9.98242C7.54678 9.98242 9.83201 9.373 10.4062 8.22461C10.4999 8.04883 10.5469 7.84961 10.5469 7.63867V6.4668C10.5469 8.00195 7.89842 8.81054 5.27343 8.81054Z"
        fill="#8B90A4"
      />
      <path
        d="M14.6478 18.1851C13.5692 18.1851 12.4972 18.0411 11.596 17.7737C11.4794 18.1383 11.2778 18.4633 11.0098 18.7524C12.002 19.1514 13.3271 19.3569 14.6478 19.3569C17.2728 19.3569 19.9994 18.5483 19.9994 17.0132V15.8413C19.9994 17.3765 17.2728 18.1851 14.6478 18.1851Z"
        fill="#8B90A4"
      />
      <path
        d="M14.6484 13.4975C13.6182 13.4975 12.5935 13.3661 11.7188 13.1222C11.7188 13.7807 11.7188 13.6392 11.7188 14.2977C12.5938 14.541 13.6199 14.6694 14.6484 14.6694C17.2734 14.6694 20 13.8608 20 12.3257V11.1538C20 12.9419 16.5449 13.4975 14.6484 13.4975Z"
        fill="#8B90A4"
      />
      <path
        d="M14.6484 15.8413C13.615 15.8413 12.5957 15.702 11.7188 15.4556C11.7188 15.8899 11.7188 15.6269 11.7188 16.6334C12.5922 16.88 13.6156 17.0132 14.6484 17.0132C16.5608 17.0132 20 16.4559 20 14.6694V13.4976C20 15.0327 17.2734 15.8413 14.6484 15.8413Z"
        fill="#8B90A4"
      />
      <path
        d="M11.7188 8.03717V11.9372C12.5939 12.1861 13.6136 12.3258 14.6484 12.3258C17.2691 12.3258 20 11.5207 20 9.98201C20 7.83963 14.8221 7.1951 11.7188 8.03717Z"
        fill="#8B90A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_7318_63439">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
